module.exports = __webpack_public_path__ + "img/avatar.11802fed.png";